import api from './api';

export default async function selectErgoById(payload) {
  const { data } = await api.get(`ergo/${payload}`);
  return data;
}
